export const SURGERY_ROOM = 'surgeryRoom';
